import { ReactElement, useEffect, useState } from 'react';
import BlockComponentImage from '../../models/BlockComponentValues/BlockComponentImage';
import CroppedImage from '../CroppedImage';
import ControlButtons from './ModalControls';

interface ImageEnlargeModalProps {
  targetModalId: string;
  images: BlockComponentImage[];
}

// eslint-disable-next-line arrow-body-style
const ImageEnlargeModal = ({ images: incomingImages, targetModalId }: ImageEnlargeModalProps) => {
  const modalId = `image-showcase-${targetModalId}`;

  const [displayingIndex, setDisplayingIndex] = useState<number>(0);
  const [convertedImages, setConvertedImages] = useState<ReactElement[]>([]);

  const hideAllImages = () => {
    const images = document.querySelectorAll('.image-container') as unknown as HTMLElement[];
    images.forEach((image) => {
      image.style.display = 'none';
    });
  };

  const displaySelectedImage = () => {
    const selectedImage = document.querySelector(`.image-container[data-unique-value="${convertedImages[displayingIndex].props.image.uniqueId}"]`) as HTMLElement;
    selectedImage.style.display = 'block';
  };

  const goToPrev = () => {
    hideAllImages();

    setDisplayingIndex((prevIndex) => {
      if (prevIndex === 0) return convertedImages.length - 1;
      return prevIndex - 1;
    });

    displaySelectedImage();
  };

  const goToNext = () => {
    hideAllImages();

    setDisplayingIndex((prevIndex) => {
      if (prevIndex === convertedImages.length - 1) return 0;
      return prevIndex + 1;
    });

    displaySelectedImage();
  };

  useEffect(() => {
    const imagesToConvert = incomingImages.filter((image) => image?.settings?.enableViewer);

    const converted = imagesToConvert.map((image) => (
      <CroppedImage
        key={image?.uniqueId}
        image={image}
        settings={image?.settings}
      />
    ));

    setConvertedImages(converted);
  }, [incomingImages]);

  return (
    <div
      className="modal fade"
      id={modalId}
      tabIndex={-1}
      aria-labelledby="image-modal-label"
      aria-hidden="true"
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1000,
      }}
    >
      <div className="d-flex justify-content-end">
        <button
          type="button"
          className="btn-close btn-close-white"
          data-bs-dismiss={modalId}
          aria-label="Close"
          style={{
            fontSize: '4rem',
            zIndex: 100,
          }}
          onClick={() => {
            const modal = document.getElementById(modalId);
            if (modal) {
              modal.classList.remove('show');
              modal.style.display = 'none';
            }
          }}
        />
      </div>

      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          height: 'calc(100vh - 100px)',
        }}
      >
        <div className="d-flex justify-content-between align-items-center flex-row w-100 p-3">
          <ControlButtons
            goToNext={goToNext}
            goToPrev={goToPrev}
            shouldApply={convertedImages.length > 1}
          >
            {convertedImages.map((image) => (
              <div
                key={image?.props?.image?.uniqueId}
                data-unique-value={image?.props?.image?.uniqueId}
                className="image-container w-100 h-100"
              >
                {image}
              </div>
            ))}
          </ControlButtons>
        </div>
      </div>
    </div>
  );
};

export default ImageEnlargeModal;
